import { Vue } from "vue/types/vue";

export type Ref = Vue | Element | (Vue | Element)[] | undefined;

export function isVue(el: Vue | Element): el is Vue {
  return !!(el as Vue).$el;
}

export function getElement<T extends Element>(el: Ref, index = 0): T {
  const getter = (el: Vue | Element): T => {
    if (isVue(el)) return el.$el as T;
    else return el as T;
  };
  if (!el || (Array.isArray(el) && (el.length === 0 || index >= el.length))) {
    throw new Error("Element not found");
  }

  if (Array.isArray(el)) return getter(el[index]);
  return getter(el);
}

export function applyOnElement(els: Ref, callee: (el: Element) => void) {
  if (Array.isArray(els)) {
    els.forEach((el: Vue | Element) => callee(getElement(el)));
  } else callee(getElement(els));
}

export function elementHasParent(target: Element, ancestor: Element): boolean {
  if (!target.parentElement) return false;
  return target.parentElement === ancestor || elementHasParent(target.parentElement, ancestor);
}
